/*!
 * Stimpack Nav
 *
 * @package : stimpack
 * @version : 0.1
 */

import { spIsBase64, spBase64Decode, spGetAnchorTarget, spIsBreakpointReached } from '../utilities/utilities';


(function($) {

    var spNavigationCount = 0;

    var spNavigation = function(el, options)
    {
        var _this = this,
            root = $(el);

        spNavigationCount++;

        // Options
        this.defaultOptions = {
            type            : 'nav',
            breakpoint      : 1100,

            subNavType      : '',
            subNavEvent     : 'hover',
            subNavPosition  : 'bottom',
            subNavAlignment : 'center',
            subNavOffset    : 0,

            popoverLayout   : '',

            expandFullScreen      : false,

            selectors       : {
                nav             : '.sp-navigation-nav',
                navItem         : 'li',

                subNav          : '.sp-navigation-sub-nav',

                link            : 'a',
                collapseButton  : '.sp-navigation-collapse-button',
            },

            remoteContainer     : '',

            sticky              : false
        };

        if (typeof options === 'object')
        {
            this.options = $.extend({}, this.defaultOptions, options);

            if (options.selectors)
            {
                this.options.selectors = $.extend({}, this.defaultOptions.selectors, options.selectors);
            }
        }
        else
        {
            this.options = this.defaultOptions;
        }

        // Elements
        this.el = {root : root};
        this.el.root.inner = root.children().first();


        this.init();

        return this;
    };

    /* ---------------------------------------------------------------------- */
    /* Helpers
    /* ---------------------------------------------------------------------- */

    /**
     * Add class
     */
    spNavigation.prototype.addClass = function(string)
    {
        var el = this.options.remoteContainer ? $(this.options.remoteContainer) : null;

        if (el && el.length > 0)
        {
            el.addClass(string);
        }

        this.el.root.addClass(string);
    };

    /**
     * Remove class
     */
    spNavigation.prototype.removeClass = function(string)
    {
        var el = this.options.remoteContainer ? $(this.options.remoteContainer) : null;

        if (el && el.length > 0)
        {
            el.removeClass(string);
        }

        this.el.root.removeClass(string);
    };

    /**
     * Is breakpoint reached
     */
    spNavigation.prototype.isBreakpointReached = function()
    {
        if (this.options.breakpoint && $(window).width() <= this.options.breakpoint)
        {
            return true;
        }

        return false;
    };

    /*
     * On Scroll
     */
    spNavigation.prototype.getTopOffset = function()
    {
        var offset = $('#header').outerHeight();

        return offset;
    };

    spNavigation.prototype.getCurrentNavItem = function()
    {
        var current = this.el.nav.inner.children('.current-menu-item, .current-menu-parent, .current-menu-ancestor');

        if (current.length > 0)
        {
            return current.first();
        }
    };

    /* ---------------------------------------------------------------------- */
    /*
    /* ---------------------------------------------------------------------- */

    /*
     * Init
     */
    spNavigation.prototype.init = function()
    {
        var _this = this;

        if ('select' === this.options.type)
        {
            this.initSelect();
        }
        else
        {
            this.initNav();
            this.initCollapse();

            if ('popover' === this.options.subNavType)
            {
                this.initPopover();
            }
        }

        this.initScroll();

        $(window).resize(function() {
            _this.update();
        });

        this.update();

        this.addClass('sp-navigation-initiated');
    };

    /*
     * Init Nav
     */
    spNavigation.prototype.initScroll = function()
    {
        var _this = this;

        this.lastScroll = $(window).scrollTop;
        this.scrollDirection = 'down';
        this.scrollPosition = 'before';

        $(window).on('scroll', function() {
            _this.onScroll();
        });
    };



    /*
     * On Scroll
     */
    spNavigation.prototype.onScroll = function()
    {
        var _this = this,
            scrollTop = $(window).scrollTop(),
            positionTop = this.el.root.offset().top,
            positionBottom = positionTop + this.el.root.outerHeight();

        var scrollTopTotal = scrollTop + this.getTopOffset();

        // Direction
        this.scrollDirection = scrollTop > this.lastScroll ? 'down' : 'up';

        // Position
        if (scrollTopTotal < positionTop)
        {
            this.scrollPosition = 'before';
        }
        else if (scrollTopTotal > positionBottom)
        {
            this.scrollPosition = 'after';
        }
        else
        {
            this.scrollPosition = 'in';
        }

        if (this.options.sticky) {

            if (scrollTopTotal >= positionBottom)
            {
                this.el.root.addClass('sp-navigation-sticked').height(this.el.root.inner.height());
                this.el.root.removeClass('sp-navigation-scroll-no-transition');
                this.el.root.inner.css('top', this.getTopOffset());
            }
            else if ('up' === this.scrollDirection && scrollTopTotal <= positionTop)
            {
                this.el.root.addClass('sp-navigation-scroll-no-transition');
                this.el.root.removeClass('sp-navigation-sticked').height('auto');
                this.el.root.inner.css('top', 'auto');
            }
        }

        this.el.root.attr('data-scroll-direction', this.scrollDirection);
        this.el.root.attr('data-scroll-position', this.scrollPosition);

        this.el.nav.find(this.options.selectors.navItem).each(function() {

            var item = $(this),
                target = item.data('sp-navigation-target');

            if (target && target.length > 0)
            {
                var start = target.offset().top,
                    end = start + target.outerHeight();

                if (scrollTopTotal >= start && scrollTopTotal < end)
                {
                    _this.el.nav.find(_this.options.selectors.navItem).removeClass('active');
                    item.addClass('active');
                }
                else
                {
                    item.removeClass('active');
                }
            }
        });

        this.lastScroll = scrollTop;
    };


    spNavigation.prototype.onNavItemClik = function()
    {

    };

    /*
     * Init Nav
     */
    spNavigation.prototype.initNav = function()
    {
        var _this = this;

        this.el.nav = this.el.root.find(this.options.selectors.nav);
        this.el.nav.inner = this.el.nav.children().first();

        this.el.nav.find(this.options.selectors.navItem).each(function() {
            _this.initNavItem($(this));
        });

        setTimeout(function () {

            _this.el.nav.find(_this.options.selectors.navItem + '.header-search-nav-item > ' + _this.options.selectors.link).each(function(e) {

                var link = $(this),
                    navItem = link.closest(_this.options.selectors.navItem),
                    panelIndex = navItem.data('popover-panel-index'),
                    panel = _this.getPopoverPanel(panelIndex),
                    input = panel.find('input');

                link.on('click', function(e) {
                    e.preventDefault();
                    input.focus();
                    _this.showPopover(panelIndex);
                });

                input.on('focusout', function() {

                    if (panel.hasClass('active'))
                    {
                        _this.hidePopover();
                    }
                });

                _this.el.popover.on('mouseleave', function(e) {

                    if (input.is(':focus'))
                    {
                        _this.showPopover(panelIndex);
                    }
                });
            });
        }, 100);


        this.el.nav.on('click', '.sp-navigation-sub-nav-back-button', function(e) {
            e.preventDefault();
            $(this).closest('.sp-navigation-item-has-children').removeClass('active');
        });


        this.el.nav.on('click', this.options.selectors.link, function(e) {

            var link = $(this),
                navItem = link.closest(_this.options.selectors.navItem),
                subNav = navItem.find(_this.options.selectors.subNav).first();

            if (link.attr('href') === '#' || (_this.isBreakpointReached() && navItem.hasClass('sp-navigation-item-has-children')))
            {
                e.preventDefault();
            }
            else if (navItem.hasClass('sp-navigation-is-anchor'))
            {
                e.preventDefault();

                if (_this.el.collapseButton.length > 0)
                {
                    // TODO: create collapse method
                    //_this.el.collapseButton.addClass('collapsed');
                    //_this.el.nav.collapse('hide');
                    // TODO: Hide sub-menu here
                }

                _this.addClass('sp-navigation-auto-scrolling');

                spScroll({
                    target  : navItem.data('sp-navigation-target'),
                    onDone  : function() {
                        _this.el.root.attr('data-scroll-direction', 'down');
                        _this.removeClass('sp-navigation-auto-scrolling');
                    }
                });
            }

            if (subNav.length > 0)
            {
                navItem.toggleClass('active');
            }
        });



        var timeoutMainHover = 0;

        this.el.nav.on('mouseenter', this.options.selectors.link, function() {
            $(this).closest(_this.options.selectors.navItem).addClass('hover');
            _this.el.root.addClass('active');
        });

        this.el.nav.on('mouseleave', this.options.selectors.link, function() {
            $(this).closest(_this.options.selectors.navItem).removeClass('hover');
        });
    };

    spNavigation.prototype.initNavItem = function(navItem)
    {
        var subNav = navItem.find(this.options.selectors.subNav),
            anchor = spGetAnchorTarget(navItem.find(this.options.selectors.link).first());

        if (anchor)
        {
            navItem.addClass('sp-navigation-is-anchor');
            navItem.data('sp-navigation-target', anchor);
        }

        if (subNav.length > 0 )
        {
            //navItem.addClass('sp-navigation-has-sub-nav');
            subNav.find('> ul').prepend('<li class="sp-navigation-item sp-navigation-sub-nav-back"><a class="sp-navigation-sub-nav-back-button" href="#"> <span class="sp-navigation-item-icon"><i class="far fa-angle-left"></i></span> <span class="sp-navigation-item-text">' + navItem.find('> a').text() + '</span> </a></span></li>');
        }
    };



    /*
     * Init Collapse
     */
    spNavigation.prototype.initCollapse = function()
    {
        var _this = this;

        this.el.collapseButton = this.el.root.find(this.options.selectors.collapseButton);
        this.el.collapseButton.text = this.el.collapseButton.find('.sp-navigation-collapse-button-text');

        if (this.el.collapseButton.length > 0)
        {
            var textSource = this.getCurrentNavItem() || this.el.nav.inner.children().first();

            if (textSource.length > 0)
            {
                textSource.addClass('sp-navigation-collapse-button-text-source');
                this.el.collapseButton.text.text(textSource.text());
            }

            if (this.options.expandFullScreen)
            {
                this.el.root.addClass('sp-navigation-full-screen-expand');
            }

            this.el.collapseButton.on('click', function(e) {
                e.preventDefault();
                _this.el.collapseButton.toggleClass('collapsed');
                //_this.el.nav.collapse('toggle');
                //$(_this.el.nav[0]).collapse('toggle');
                $(_this.el.nav[0]).toggleClass('show');
            });

            this.el.nav.on('show.bs.collapse', function(e) {

                if ($(e.target)[0] === _this.el.nav[0])
                {
                    if (_this.options.expandFullScreen)
                    {
                        $('body').addClass('sp-navigation-full-screen-expanded');
                    }

                    _this.addClass('sp-navigation-expanded');
                }
            });

            this.el.nav.on('hide.bs.collapse', function(e) {

                if ($(e.target)[0] === _this.el.nav[0])
                {
                    if (_this.options.expandFullScreen)
                    {
                        $('body').removeClass('sp-navigation-full-screen-expanded');
                    }

                    _this.removeClass('sp-navigation-expanded');
                }
            });
        }
    };

    /*
     * Init Collapse
     */
    spNavigation.prototype.initSelect = function()
    {
        var _this = this;

        this.el.select = this.el.root.find('.sp-navigation-select');

        this.el.select.on('change', function() {

            var url = _this.el.select.val();

            if (url && !_this.el.select.find(':selected').hasClass('current') && url !== window.location.href)
            {
                window.location.replace(url);
            }
        });
    };

    /* ---------------------------------------------------------------------- */
    /*
    /* ---------------------------------------------------------------------- */

    /*
     * Update
     */
    spNavigation.prototype.update = function()
    {
        if (this.isBreakpointReached())
        {
            this.addClass('sp-navigation-minimized');
        }
        else
        {
            this.removeClass('sp-navigation-minimized');
        }
    };



    /* ---------------------------------------------------------------------- */
    /*
    /* ---------------------------------------------------------------------- */

    /*
     * Init Popover
     */
    spNavigation.prototype.initPopover = function()
    {
        var _this = this,
            popover = $('<div class="sp-navigation-popover-root">' +
            '<div class="sp-navigation-popover-root-inner">' +
            '<div class="sp-navigation-popover">' +
            '<div class="sp-navigation-popover-content"></div>' +
            '<span class="sp-navigation-popover-marker"></span>' +
            '</div>' +
            '</div>' +
            '</div>');

        this.addClass('sp-navigation-sub-nav-popover');

        this.el.popover = popover.find('.sp-navigation-popover');
        this.el.popover.root = popover.find('.sp-navigation-popover-root');
        this.el.popover.content = popover.find('.sp-navigation-popover-content');
        this.el.popover.marker = popover.find('.sp-navigation-popover-marker');

        this.popoverHideTimeout = 0;
        this.popoverNoTransitionTimeout = 0;
        this.deactivatePopoverTransition();

        this.el.root.inner.append(popover);

        if ('click' === this.options.subNavEvent)
        {
            this.initPopoverClick();
        }
        else
        {
            this.initPopoverHover();
        }

        this.el.nav.inner.children(this.options.selectors.navItem).each(function() {
            _this.initPopoverPanel($(this));
        });

        //this.initPopoverSlider();

            /*function () {

                var el = $(this),
                    li = el.closest('li'),
                    index = li.data('slide-index'),
                    panel = li.closest('.sp-navigation-popover-panel'),
                    slide = panel.find('.sp-navigation-popover-panel-slide-default');

                panel.find('.sp-navigation-popover-panel-slide.active').removeClass('active');
                slide.addClass('active');
                //panel.find('.sp-navigation-popover-panel-slider-inner').height(slide.outerHeight());

                _this.resizePopover();
            }
        );*/
    };




    spNavigation.prototype.initPopoverHover = function(item)
    {
        var _this = this;

        this.el.nav.on('mouseenter', this.options.selectors.navItem, function() {

            var paneIndex = $(this).data('popover-panel-index');

            if (typeof paneIndex != 'undefined')
            {
                _this.showPopover(paneIndex);
            }
            else
            {
                _this.hidePopover();
            }
        });

        this.el.nav.on('mouseleave', this.options.selectors.navItem, function() {
            _this.hidePopover();
        });

        this.el.popover.on('mouseenter', function(e) {
            _this.showPopover();
        });

        this.el.popover.on('mouseleave', function() {
            _this.hidePopover();
        });
    };

    spNavigation.prototype.initPopoverClick = function(item)
    {
        var _this = this;

        this.el.nav.on('click', this.options.selectors.link, function(e) {

            var link = $(this),
                href = link.attr('href'),
                paneIndex = link.data('popover-panel-index');

            if ('' === href || '#' === href || _this.isBreakpointReached())
            {
                e.preventDefault();
            }

            if (typeof paneIndex != 'undefined')
            {
                _this.showPopover(paneIndex);
            }
            else
            {
                _this.hidePopover();
            }
        });
    };

    /*
     * Init Popover Panel
     */
    spNavigation.prototype.initPopoverPanel = function(item)
    {
        var _this = this,
            subNav = item.find(this.options.selectors.subNav).first();

        if (!subNav.is('ul'))
        {
            subNav = subNav.find('ul').first();
        }

        if (subNav.length > 0)
        {
            subNav = subNav.clone(true);
            subNav.removeClass('sp-navigation-sub-nav-inner');

            var subNavItems = subNav.find('> li'),
                panel = $('<div class="sp-navigation-popover-panel" data-nav-index="' + item.index() + '"><div class="sp-navigation-popover-panel-inner"></div></div>'),
                panelIndex = this.el.popover.content.find('.sp-navigation-popover-panel').length;

            if (item.hasClass('sp-navigation-sub-nav-row'))
            {
                panel.addClass('sp-navigation-popover-panel-horizontal');
            }

            if ('split' == this.options.popoverLayout)
            {
                var slideIndex = 0;
                var description = item.find('> .sp-navigation-item-description');

                var panelRow = $('<div class="sp-navigation-popover-panel-row"></div>');

                var panelNav = $('<div class="sp-navigation-popover-panel-nav"><div class="sp-navigation-popover-panel-nav-inner"></div></div>');
                    panelNav.find('.sp-navigation-popover-panel-nav-inner').append(subNav);

                var panelSlider = $('<div class="sp-navigation-popover-panel-slider"><div class="sp-navigation-popover-panel-slider-inner"></div></div>'),
                    panelSliderInner = panelSlider.find('.sp-navigation-popover-panel-slider-inner');

                panel.addClass('sp-navigation-popover-panel-splitted');

                if (description.length > 0)
                {
                    panelSliderInner.append('<div class="sp-navigation-popover-panel-slide sp-navigation-popover-panel-slide-default sp-navigation-popover-panel-slide-description active"><div class="sp-navigation-popover-panel-slide-inner">' + description.html() + '</div></div>');
                    slideIndex++;
                }

                subNavItems.each(function() {

                    var subNavItem = $(this),
                        subNavItemChildren = subNavItem.find(_this.options.selectors.subNav).first(),
                        subNavItemDescription = subNavItem.find('> .sp-navigation-item-description');

                    if (subNavItemChildren.length > 0)
                    {
                        var slide = $('<div class="sp-navigation-popover-panel-slide sp-navigation-popover-panel-slide-nav"><div class="sp-navigation-popover-panel-slide-inner"></div></div>');
                        slide.find('.sp-navigation-popover-panel-slide-inner').append(subNavItemChildren);
                        panelSliderInner.append(slide);
                        subNavItem.attr('data-slide-index', slideIndex++);

                        var subNavItemChildrenItems = subNavItemChildren.find('li');

                        if (subNavItemChildrenItems.length > 9)
                        {
                            var num_cols = Math.ceil(subNavItemChildrenItems.length / 9),
                            container = subNavItemChildren.find('> ul'),
                            listItem = 'li',
                            listClass = 'sub';
                            container.each(function() {
                                container.addClass('sub-nav-columns');
                                var items_per_col = new Array(),
                                items = $(this).find(listItem),
                                min_items_per_col = Math.floor(items.length / num_cols),
                                difference = items.length - (min_items_per_col * num_cols);
                                for (var i = 0; i < num_cols; i++) {
                                    if (i < difference) {
                                        items_per_col[i] = min_items_per_col + 1;
                                    } else {
                                        items_per_col[i] = min_items_per_col;
                                    }
                                }
                                for (var i = 0; i < num_cols; i++) {
                                    $(this).append($('<ul></ul>').addClass(listClass));
                                    for (var j = 0; j < items_per_col[i]; j++) {
                                        var pointer = 0;
                                        for (var k = 0; k < i; k++) {
                                            pointer += items_per_col[k];
                                        }
                                        $(this).find('.' + listClass).last().append(items[j + pointer]);
                                    }
                                }
                            });


                        }
                    }
                    else if (subNavItemDescription.length > 0)
                    {
                        panelSliderInner.append('<div class="sp-navigation-popover-panel-slide sp-navigation-popover-panel-slide-description"><div class="sp-navigation-popover-panel-slide-inner">' + subNavItemDescription.html() + '</div></div>');
                        subNavItem.attr('data-slide-index', slideIndex++);
                    }
                });

                panelRow.append([panelNav, panelSlider]);

                panel.find('.sp-navigation-popover-panel-inner').append(panelRow);

                _this.initPopoverPanelSlider(panel);
            }
            else
            {
                panel.find('.sp-navigation-popover-panel-inner').append(subNav);
            }


            //columnItems = subNav.find('> [class*="sp-navigation-popover-panel-column-"]');

            //panel.find('.sp-navigation-popover-panel-inner').append(subNav.clone(true));

            // Columns ------------------------------------------------------ //

            /*if (columnItems.length)
            {
                var row = $('<div class="sp-navigation-popover-panel-row"></div>'),
                    column,
                    items;

                for (var i = 1; i <= 5; i++)
                {
                    items = columnItems.filter('.sp-navigation-popover-panel-column-' + i);

                    if (items.length > 0)
                    {
                        column = $('<div class="sp-navigation-popover-panel-column sp-navigation-popover-panel-column-' + i + '"><ul></ul></div>');
                        column.find('ul').append(items.clone(true));
                        row.append(column);
                    }
                }

                // Remaining Items ------------------------------------------ //

                var remainingItems = subNavItems.not(columnItems);

                if (remainingItems.length > 0)
                {
                    column = $('<div class="sp-navigation-popover-panel-column sp-navigation-popover-panel-column-' + i + '"><ul></ul></div>');
                    column.find('ul').append(remainingItems);
                    row.prepend(column);
                }

                panel.find('.sp-navigation-popover-panel-inner').append(row);
            }*/


            this.el.popover.content.append(panel);

            item.attr('data-popover-panel-index', panelIndex);
        }
    };

    spNavigation.prototype.initPopoverPanelSlider = function(panel)
    {
        var _this = this;

        this.initPopoverPanelSliderLeaveTimeout = 0;


        panel.find('.sp-navigation-popover-panel-slider').on('mouseenter', function () {
            clearTimeout(_this.initPopoverPanelSliderLeaveTimeout);
        });

        panel.find('.sp-navigation-popover-panel-nav a').on('mouseenter', function () {

            var el = $(this),
                li = el.closest('li'),
                index = li.data('slide-index');

            clearTimeout(_this.initPopoverPanelSliderLeaveTimeout);

            if (index)
            {
                var slide = panel.find('.sp-navigation-popover-panel-slide').eq(index);

                if (slide.length)
                {
                    panel.find('.sp-navigation-popover-panel-nav a.active').removeClass('active');
                    el.addClass('active');

                    panel.find('.sp-navigation-popover-panel-slide.active').removeClass('active');
                    slide.addClass('active');

                    //panel.find('.sp-navigation-popover-panel-slider-inner').height(slide.outerHeight());
                }
            }
            else
            {
                _this.resetPopoverPanelSlider(panel);
            }

            _this.resizePopover();
        });

        panel.find('.sp-navigation-popover-panel-nav a').on('mouseleave', function () {

            _this.initPopoverPanelSliderLeaveTimeout = setTimeout(function () {
                _this.resetPopoverPanelSlider(panel);
            }, 200);
        });
    }

    spNavigation.prototype.resetPopoverPanelSlider = function(panel)
    {
        panel.find('.sp-navigation-popover-panel-nav a.active').removeClass('active');
        panel.find('.sp-navigation-popover-panel-slide.active').removeClass('active');
        panel.find('.sp-navigation-popover-panel-slide-default').addClass('active');
        this.resizePopover();
    }

    /*
     * Get Popover Panel
     */
    spNavigation.prototype.getPopoverPanel = function(index)
    {
        var panel;

        if (typeof index == 'undefined' || index === '')
        {
            panel = this.el.popover.content.children('.sp-navigation-popover-panel.active');
        }
        else
        {
            panel = this.el.popover.content.children('.sp-navigation-popover-panel').eq(index);
        }

        panel.linkedNavItem = this.el.nav.inner.children(this.options.selectors.navItem).eq(panel.data('nav-index'));

        return panel;
    };

    /*
     * Show Popover
     */
    spNavigation.prototype.showPopover = function(index)
    {
        if (this.options.breakpoint && $(window).width() < this.options.breakpoint)
        {
            return;
        }

        this.activatePopoverTransition();
        clearTimeout(this.popoverHideTimeout);

        var panel = this.getPopoverPanel(index);

        if (!panel.hasClass('active'))
        {
            this.el.popover.content.children('.active').removeClass('active');
            panel.addClass('active');

            this.el.nav.find(this.options.selectors.navItem + '.active').removeClass('active');

            this.resizePopover();
            this.positionPopover();
        }

        panel.linkedNavItem.addClass('active');

        this.addClass('sp-navigation-popover-active');
        this.el.popover.addClass('active');
    };

    /*
     * Hide Popover
     */
    spNavigation.prototype.hidePopover = function()
    {
        if (this.options.breakpoint && $(window).width() < this.options.breakpoint)
        {
            return;
        }

        var _this = this;

        clearTimeout(this.popoverHideTimeout);

        this.popoverHideTimeout = setTimeout(function() {

            _this.deactivatePopoverTransition();

            var panel = _this.getPopoverPanel();

            _this.removeClass('sp-navigation-popover-active');
            _this.el.popover.removeClass('active');

            panel.linkedNavItem.removeClass('active');
            _this.el.root.removeClass('active');

        }, 200);
    };

    /*
     * Resize Popover
     */
    spNavigation.prototype.resizePopover = function()
    {
        var activePanel = this.el.popover.find('.sp-navigation-popover-panel.active'),
            activePanelInner = activePanel.find('> div'),
            slider = activePanel.find('.sp-navigation-popover-panel-slider');

        var sizes = {
            width   : activePanelInner[0].offsetWidth,
            height  : activePanelInner[0].offsetHeight
        };

        if (slider.length > 0)
        {
            var activeSlide = slider.find('.sp-navigation-popover-panel-slide.active');

            if (activeSlide.find('> div').outerHeight() > activePanelInner.outerHeight())
            {
                sizes.height = activeSlide.find('> div').outerHeight();
            }
        }

        this.el.popover.css(sizes);
    };

    /*
     * Position Popover
     */
    spNavigation.prototype.positionPopover = function()
    {
        var panel = this.getPopoverPanel(),
            panelWidth = panel.children().outerWidth(),
            navItem = this.el.nav.inner.children(this.options.selectors.navItem).eq(panel.data('nav-index')),
            navItemWidth = navItem.outerWidth(),
            popoverPosition = 0,
            markerPosition = 0,
            parentOffsetLeft = 0,
            finalOffsetLeft = 0;

        if ('left' == this.options.subNavAlignment)
        {
            popoverPosition = navItem.position().left;
            markerPosition = (navItemWidth / 2) - (this.el.popover.marker.outerWidth() / 2);
        }
        else if ('right' == this.options.subNavAlignment)
        {
            popoverPosition = (navItem.position().left + navItemWidth) - panelWidth;
            markerPosition = panelWidth - ((navItemWidth / 2) + (this.el.popover.marker.outerWidth() / 2));
        }
        else
        {
            popoverPosition = (navItem.position().left + (navItemWidth / 2)) - (panelWidth / 2);
            markerPosition = (panelWidth / 2) - (this.el.popover.marker.outerWidth() / 2);
        }

        parentOffsetLeft = this.el.popover.parent().offset().left;
        finalOffsetLeft = parentOffsetLeft + popoverPosition;

        popoverPosition += parseInt(this.options.subNavOffset) || 0;

        if (finalOffsetLeft < 15)
        {
            popoverPosition = 15;
        }
        else if ((finalOffsetLeft + panelWidth) > ($(window).width() - 15))
        {
            popoverPosition -= ((finalOffsetLeft + panelWidth) - ($(window).width() - 15));
        }

        this.el.popover.marker.css('transform', 'translateX(' + markerPosition + 'px)');
        this.el.popover.css('transform', 'translateX(' + popoverPosition + 'px)');
    };

    /*
     *  Popover
     */
    spNavigation.prototype.activatePopoverTransition = function()
    {
        clearTimeout(this.popoverNoTransitionTimeout);

        var _this = this;

        this.popoverNoTransitionTimeout = setTimeout(function() {
            _this.el.root.removeClass('sp-navigation-popover-no-transition');
        }, 10);
    };

    /*
     *  Popover
     */
    spNavigation.prototype.deactivatePopoverTransition = function()
    {
        clearTimeout(this.popoverNoTransitionTimeout);

        var _this = this;

        this.popoverNoTransitionTimeout = setTimeout(function() {
            _this.el.root.addClass('sp-navigation-popover-no-transition');
        }, 10);
    };

    /* ---------------------------------------------------------------------- */
    /*
    /* ---------------------------------------------------------------------- */

    $.fn.spNavigation = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-navigation');

            $(this).attr('data-sp-navigation', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, _options ? JSON.parse(spBase64Decode(_options)) : {});
                }
            }

            this.spNavigation = new spNavigation(this, options);
        });
    };

    // Declaration
    $('[data-sp-navigation]').each(function() {
        $(this).spNavigation();
    });

})(jQuery);
